export default __webpack_public_path__ + "static/media/PPI-pools-018.7eb04b49.jpg";